import React from "react";
import PropTypes from "prop-types";
import getPrettyNumberFormat from "../../../helpers/getPrettyNumberFormat";
import PhasingGroup from "../models/PhasingGroup";
import ZoomToRegion from "../../../components/TooltipActions/ZoomToRegion";
import Track from "../../../models/Track";

function PhasingGroupDetails({
  phasingGroup,
  requestClose,
  track,
  allowActions,
  colors,
}) {
  const { region, indMod, id, variantCount } = phasingGroup || {};

  const start = getPrettyNumberFormat(region?.x0);
  const end = getPrettyNumberFormat(region?.x1);
  const length = getPrettyNumberFormat(region?.size + 1);
  const phaseBg = colors[indMod || 0];

  return id ? (
    <>
      <div
        className="tw-flex"
        data-tooltip={`Start: ${start}<br/>End: ${end}<br/>Length: ${length}<br/>Variants: ${variantCount}`}
        data-tooltip-class="genome-browser-small-tooltip"
        data-tooltip-dangerous-html={true}
      >
        {phasingGroup.origId}

        <div className="tw-w-2" />
        <div
          className="tw-w-3 tw-h-3 tw-rounded-full"
          style={{ backgroundColor: phaseBg }}
        />
      </div>
      {allowActions ? (
        <>
          <div className="tw-w-2" />
          <ZoomToRegion
            requestClose={requestClose}
            jumpTo={track.zoomService.jumpTo}
            region={region}
          />
        </>
      ) : null}
    </>
  ) : (
    <div>-</div>
  );
}

PhasingGroupDetails.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.string).isRequired,
  allowActions: PropTypes.bool.isRequired,
  track: PropTypes.instanceOf(Track).isRequired,
  phasingGroup: PropTypes.instanceOf(PhasingGroup),
  requestClose: PropTypes.func,
};

PhasingGroupDetails.defaultProps = {
  requestClose: () => {},
  phasingGroup: null,
};

export default React.memo(PhasingGroupDetails);
